import { ComponentMap } from '@cinch-nx/data-storyblok'
import { landingStoryblokComponents } from '@cinch-nx/landing-ui-shared'
import { PreFooterCtaV2Wrapper } from '../../components/pre-footer-cta-v2-wrapper'

import { RichTextWrapper } from '../../components/rich-text-wrapper/rich-text-wrapper'
import { FeatureCardRowWrapper } from '../../components/feature-card-row-wrapper'
import {
  SectionWithImageV2Wrapper,
  TextInlineImageSectionWrapper,
} from '../../components'
import { FindASiteWrapper } from '../../components/find-a-site-wrapper/find-a-site-wrapper'

const localStoryblokComponents: ComponentMap = {
  LandingTextInlineImageSection: TextInlineImageSectionWrapper,
  SectionWithImageV2: SectionWithImageV2Wrapper,
  FeatureCardRowWrapper: FeatureCardRowWrapper,
  PreFooterCtaV2: PreFooterCtaV2Wrapper,
  RichText: RichTextWrapper,
  FindASite: FindASiteWrapper,
}

export const storyblokComponentsCollections: ComponentMap = {
  ...landingStoryblokComponents,
  ...localStoryblokComponents,
}
